export default __webpack_public_path__ + "static/media/StackedBarChartBlue.c64a8a4b.svg";